export default "__VITE_ASSET__DtsEk967__"